import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpService } from '@flexo/general';

const ENV = (import.meta as any).env;

/**
 * Audit user alignment between Clerk and Catalog
 */
export const AuditUsersAsync = createAsyncThunk(
  'audit/AuditUsersAsync',
  async function (options?: { includeAligned?: boolean }) {
    const includeAligned = options?.includeAligned ?? false;
    const response = await httpService.get({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/users/audit?includeAligned=${includeAligned}`,
      mock: false,
    });

    if (response.status === 200) {
      const data = response.data;
      const users = includeAligned
        ? data?.allUsers || data?.usersWithIssues || []
        : data?.usersWithIssues || [];

      return {
        results: users,
        summary: data?.summary || null,
        lastAuditAt: data?.auditTimestamp || new Date().toISOString(),
      };
    }
    throw new Error('Failed to audit users');
  }
);

/**
 * Audit communities
 */
export const AuditCommunitiesAsync = createAsyncThunk(
  'audit/AuditCommunitiesAsync',
  async function () {
    const response = await httpService.get({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/communities/audit`,
      mock: false,
    });

    if (response.status === 200) {
      return {
        results: response.data?.communities || [],
        lastAuditAt: new Date().toISOString(),
      };
    }
    throw new Error('Failed to audit communities');
  }
);

/**
 * Audit sites
 */
export const AuditSitesAsync = createAsyncThunk(
  'audit/AuditSitesAsync',
  async function () {
    const response = await httpService.get({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/sites/audit`,
      mock: false,
    });

    if (response.status === 200) {
      return {
        results: response.data?.sites || [],
        lastAuditAt: new Date().toISOString(),
      };
    }
    throw new Error('Failed to audit sites');
  }
);
